/* WITS consented measurement v2. No config/page_view/purchase emitter.
 * Neutral milestones only: never quiz answers, text, names or email.
 * Uses the native Google tag/session; does not create tracking cookies.
 */
(() => {
  'use strict';
  if (window.__witsMeasurementV2) return;
  window.__witsMeasurementV2 = true;
  const registry = {"/pages/find-your-focus":["quiz-focus","20261104","quiz"],"/pages/energy-vs-focus": ["energy-vs-focus", "measurement-baseline-20260928", "article"], "/pages/why-cant-we-focus": ["why-cant-we-focus", "measurement-baseline-20260928", "listicle"], "/pages/focus-three-buttons": ["focus-three-buttons", "measurement-baseline-20260928", "article"], "/pages/never-lazy": ["never-lazy", "measurement-baseline-20260928", "article"], "/pages/three-tricks": ["three-tricks", "measurement-baseline-20260928", "article"], "/pages/qc0c9280429d515c2": ["original_6", "measurement-baseline-20260928", "listicle"], "/pages/qs9d7a31c64e2": ["original_8", "measurement-baseline-20260928", "listicle"], "/pages/qf5a8c21d903e": ["qf5a8c21d903e", "measurement-baseline-20260928", "listicle"], "/pages/rk7c4e91a2b60": ["rk7c4e91a2b60", "measurement-baseline-20260928", "article"], "/pages/6-reasons-wits-back-to-back-calls-ls": ["6-reasons-wits-back-to-back-calls-ls", "measurement-baseline-20260928", "listicle"], "/pages/mood-and-focus-quiz": ["social_quiz", "measurement-baseline-20260928", "quiz"], "/pages/6-reasons-to-try-wits-for-mood-and-focus-ls": ["social_6", "measurement-baseline-20260928", "listicle"], "/pages/8-reasons-to-try-wits-for-mood-and-focus-ls": ["social_8", "measurement-baseline-20260928", "listicle"], "/pages/mood-and-focus-quiz-6": ["mood-and-focus-quiz-6", "measurement-baseline-20260928", "quiz"], "/pages/mood-and-focus-quiz-10": ["mood-and-focus-quiz-10", "measurement-baseline-20260928", "quiz"], "/pages/6-reasons-happier-mood-deeper-focus-ls": ["6-reasons-happier-mood-deeper-focus-ls", "measurement-baseline-20260928", "listicle"], "/pages/8-reasons-happier-mood-deeper-focus-ls": ["8-reasons-happier-mood-deeper-focus-ls", "measurement-baseline-20260928", "listicle"], "/pages/better-mood-deep-focus": ["better-mood-deep-focus", "measurement-baseline-20260928", "landing"], "/pages/8-reasons-to-try-wits-saffron-focus-mints-ls": ["8-reasons-to-try-wits-saffron-focus-mints-ls", "measurement-baseline-20260928", "listicle"], "/": ["homepage", "measurement-baseline-20260928", "landing"]};
  const path = location.pathname.replace(/\/$/, '') || '/';
  const isProduct = /^\/products\/[^/]+$/.test(path);
  const cfg = document.body?.dataset || {};
  const page = registry[path] || (isProduct ? [path.split('/').pop(), 'measurement-baseline-20260928', 'product'] : /^\/pages\//.test(path) ? [path.split('/').pop(), 'unregistered-v2', 'page'] : null);
  if (!page || !/^(www\.)?witsbrand\.com$/.test(location.hostname)) return;
  const params = new URLSearchParams(location.search);
  const qa = params.get('wits_qa') === '1' || /(?:^|[-_])qa(?:$|[-_])/i.test(params.get('utm_source') || '');
  const viewId = crypto.randomUUID();
  const sent = new Set();
  let sequence = 0, requestedPrivacy = false, activeScreen = null;
  let screenStart = performance.now(), hiddenTime = 0, hiddenAt = document.hidden ? performance.now() : null;
  const allowed = () => {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true && typeof window.gtag === 'function'; }
    catch (_) { return false; }
  };
  const names = new Set(['wits_content_view','wits_pdp_arrival','wits_scroll','wits_section_view','wits_reason_view','wits_cta_click','wits_quiz_start','wits_quiz_step','wits_quiz_answered','wits_quiz_result','wits_tip_view','wits_tip_continue','wits_image_view']);
  const fieldsAllowed = new Set(['step_number','total_steps','elapsed_ms','screen_type','reason_number','final_reason','section_number','section_id','cta_id','destination_path','percent_scrolled','image_id','placement_id']);
  function emit(name, fields = {}, key) {
    if (!names.has(name) || !allowed() || document.hidden || (key && sent.has(key))) return false;
    const safe = {};
    for (const [k,v] of Object.entries(fields)) {
      if (fieldsAllowed.has(k) && (typeof v === 'number' && Number.isFinite(v) || typeof v === 'string' && /^[a-zA-Z0-9_./:-]{1,100}$/.test(v))) safe[k] = v;
    }
    try {
      window.gtag('event', name, {send_to:'G-Z0RPFT5ZZ0', transport_type:'beacon',
        page_id:page[0], page_version:page[1], content_type:page[2], measurement_version:'2',
        page_view_id:viewId,event_id:viewId+':'+(++sequence),qa_traffic:qa?'true':'false',...safe});
      if (qa) console.info('[WITS measurement QA] '+JSON.stringify({name,page_id:page[0],measurement_version:'2',...safe}));
      if (key) sent.add(key);
      return true;
    } catch (_) { return false; }
  }
  const once = (name,key,fields) => emit(name,fields,key);
  const elapsed = () => Math.max(0,Math.round(performance.now()-screenStart-hiddenTime-(hiddenAt===null?0:performance.now()-hiddenAt)));
  function screenView(n,total,type='question') {
    screenStart=performance.now();hiddenTime=0;hiddenAt=document.hidden?performance.now():null;
    activeScreen={n,total,type};
    requestAnimationFrame(inspect);
    if (type==='question') once('wits_quiz_step','step:'+n,{step_number:n,total_steps:total});
    if (type==='result') once('wits_quiz_result','result');
  }
  // Compatibility interface consumed by the existing 6Q/10Q quiz code.
  if (cfg.pageId && cfg.pageId.startsWith('quiz-') || path.includes('happier-mood-deeper-focus')) {
    window.WitsExperiment={emit,once,screenView,elapsed,preview:[]};
  }
  function visible(node) {
    const r=node.getBoundingClientRect();
    return r.width>0 && r.height>0 && r.top<innerHeight && r.bottom>0;
  }
  function inspect() {
    if (!allowed() || document.hidden) return;
    document.querySelectorAll('[data-image-id]').forEach(n=>{
      const r=n.getBoundingClientRect();
      const area=Math.max(0,Math.min(innerHeight,r.bottom)-Math.max(0,r.top))*Math.max(0,Math.min(innerWidth,r.right)-Math.max(0,r.left));
      if(r.width>0&&r.height>0&&area/(r.width*r.height)>=.5)once('wits_image_view','image:'+n.dataset.placementId,{image_id:n.dataset.imageId,placement_id:n.dataset.placementId});
    });
    if (page[2] !== 'quiz') {
      const height=document.documentElement.scrollHeight;
      if (height>0) for (const n of [25,50,75,90,100]) {
        if ((scrollY+innerHeight)/height*100 >= n) once('wits_scroll','scroll:'+n,{percent_scrolled:n});
      }
      // Visible headings prove section reach. They do not claim all text was read.
      const headings=Array.from(document.querySelectorAll('main h2, #MainContent h2, .main-wrapper h2'));
      headings.forEach((h,i)=>{if(visible(h))once('wits_section_view','section:'+i,{section_number:i+1,section_id:'heading_'+(i+1)});});
      let reasons=Array.from(document.querySelectorAll('[data-reason]'));
      if (!reasons.length) reasons=Array.from(document.querySelectorAll('.reason12-w'));
      reasons.forEach((n,i)=>{const h=n.querySelector('h2,h3')||n;if(visible(h))once('wits_reason_view','reason:'+i,{reason_number:Number(n.dataset.reason)||i+1,final_reason:i===reasons.length-1?'true':'false'});});
    }
  }
  function start() {
    if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures && !requestedPrivacy) {
      requestedPrivacy=true;
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],err=>{if(!err)start();});
    }
    if (!allowed() || document.hidden) return;
    once(isProduct?'wits_pdp_arrival':'wits_content_view','content');
    inspect();
    if (activeScreen) {
      const {n,total,type}=activeScreen;
      if(type==='question')once('wits_quiz_step','step:'+n,{step_number:n,total_steps:total});
      if(type==='result')once('wits_quiz_result','result');
    } else if (page[2]==='quiz' && path==='/pages/mood-and-focus-quiz') {
      const n=Number(document.querySelector('[role="progressbar"]')?.getAttribute('aria-valuenow'));
      if(document.querySelector('.product-card'))once('wits_quiz_result','result');
      else if(Number.isInteger(n)&&n>=1&&n<=8&&!document.querySelector('.result-loading'))once('wits_quiz_step','step:'+n,{step_number:n,total_steps:8});
    }
  }
  let frame=false;
  const schedule=()=>{if(!frame){frame=true;requestAnimationFrame(()=>{frame=false;inspect();});}};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('load',start,{once:true});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)hiddenAt=performance.now();else{if(hiddenAt!==null)hiddenTime+=performance.now()-hiddenAt;hiddenAt=null;start();}});
  document.addEventListener('click',e=>{
    const a=e.target.closest?.('a[href]');if(!a)return;
    let u;try{u=new URL(a.href,location.href);}catch(_){return;}
    if(!/^(www\.)?witsbrand\.com$/.test(u.hostname)||!/^\/(products|pages)\//.test(u.pathname))return;
    // Carry only existing acquisition parameters across the actual journey.
    // Never replace parameters already supplied by the destination.
    for(const [k,v]of params)if(/^(utm_[a-z_]+|fbclid|gclid|ttclid|trybe|wits_qa)$/.test(k)&&!u.searchParams.has(k))u.searchParams.set(k,v);
    if(cfg.variantId&&u.pathname.startsWith('/products/')){
      if(!u.searchParams.has('wits_experiment'))u.searchParams.set('wits_experiment','7d-mood-focus');
      if(!u.searchParams.has('wits_variant'))u.searchParams.set('wits_variant',cfg.variantId);
    }
    a.href=u.href;
    const links=Array.from(document.querySelectorAll('a[href]'));
    emit('wits_cta_click',{cta_id:a.dataset.witsCta||'link_'+(links.indexOf(a)+1),destination_path:u.pathname,elapsed_ms:elapsed()});
  },{capture:true});
  window.addEventListener('wits:quiz',e=>{
    if(path!=='/pages/mood-and-focus-quiz')return;
    const d=e.detail||{};
    if(d.event==='started'){once('wits_quiz_start','quiz-start');emit('wits_quiz_answered',{step_number:1});}
    if(d.event==='answer'&&Number.isInteger(d.step_number)&&d.step_number>=2&&d.step_number<=8)emit('wits_quiz_answered',{step_number:d.step_number});
    if(d.event==='screen_view'){
      if(d.screen==='age')screenView(1,8);
      if(d.screen==='question')screenView(d.step,8);
      if(d.screen==='result')screenView(8,8,'result');
      if(d.screen==='bridge'||d.screen==='loading')activeScreen={type:d.screen};
    }
  });
  document.addEventListener('visitorConsentCollected',start);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded',start);
  let attempts=0;
  const timer=setInterval(()=>{start();if(allowed()||++attempts>=60)clearInterval(timer);},500);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
